import React from 'react';
import {BrowserRouter} from "react-router-dom"
import App from './App';
import * as serviceWorker from './serviceWorker';
import {createRoot} from "react-dom/client"
import "./css/style.css";

// Inicializamos la interfaz
const container = document.getElementById('root');
const root = createRoot(container);    

    root.render(
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    );

    serviceWorker.unregister();
// }

